<div>
  <span>{{messagePartA}}</span>
  <span>{{userName}}</span>
  <span [innerHTML]="messagePartB"></span>
</div>
